import React, { createContext } from 'react';
import { notification } from 'antd';

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  // Fixed placement: topRight
  const openNotification = (type = '', message = '') => {
    const placement = 'topRight'; // constant placement

    if (api[type]) {
      api[type]({
        message,
        placement,
        duration:2,
      });
    } else {
      console.warn(`Invalid notification type: ${type}`);
    }
  };

  return (
    <NotificationContext.Provider value={{ openNotification }}>
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};
